module.exports = __webpack_public_path__ + "img/vkb-rms-home-keyvisual.d98e8b1.jpg";